import { z } from 'zod';
import { c } from '../../contract';

export const bookShopRouter = c.router(
  {
    createPaymentIntent: {
      summary: 'Creates a new Stripe payment intent and a new draft order, sent by the app client.',
      method: 'POST',
      path: '/payment-intents',
      body: z.object({
        productId: z.coerce.number(),
        productTitle: z.string().optional(),
        variantId: z.string(),
        shippingVariantId: z.string(),
        paymentMethodId: z.string().optional(),
        currencyCode: z.string(),
        countryCode: z.string(),
      }),
      responses: {
        200: c.type<{ success: true; paymentIntent: string; orderId: string }>(),
        500: c.type<{ success: false; message: string }>(),
        400: c.type<{ success: false; message: string }>(),
      },
    },
    createBulkPaymentIntent: {
      summary: 'Creates a new Stripe bulk payment intent and a new draft order, sent by the app client.',
      method: 'POST',
      path: '/bulk-payment-intents',
      body: z.object({
        products: z.array(
          z.object({
            productId: z.coerce.number(),
            productPriceVariantId: z.string(),
            quantity: z.number(),
            bundleSize: z.number(),
          }),
        ),
        shipping: z.object({
          baseShippingProductId: z.coerce.number(),
          baseShippingPriceId: z.string(),
          extraShippingItemsCount: z.number(),
        }),
        totalPrice: z.number(),
        paymentMethodId: z.string().optional(),
        currencyCode: z.string(),
        countryCode: z.string(),
      }),
      responses: {
        200: c.type<{ success: true; paymentIntent: string; orderId: string }>(),
        500: c.type<{ success: false; message: string }>(),
        400: c.type<{ success: false; message: string }>(),
      },
    },
  },
  { pathPrefix: '/book-shop' },
);
